<template>
  <div class="mb--3">
    <label>{{ title }}</label>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["title"]
};
</script>
